import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UpdateUserStateResultModal} from './update-user-state.result.modal';
import {
    clearResult,
    selectUpdateUserStateBulkUuid,
    selectUpdateUserStateShown,
    selectUpdateUserStateTask,
} from './update-user-state.slice';


export const UpdateUserStateResult = () => (
    <BulkActionResult
        actionIdSelector={selectUpdateUserStateBulkUuid}
        actionTaskSelector={selectUpdateUserStateTask}
        actionShownSelector={selectUpdateUserStateShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <UpdateUserStateResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
